import React from 'react';
export function Footer() {
  return <footer className="py-8 px-4 bg-black border-t border-zinc-900 text-center" data-id="element-77">
      <div className="max-w-5xl mx-auto flex flex-col md:flex-row justify-between items-center gap-4 text-zinc-600 text-sm" data-id="element-78">
        <p data-id="element-79">© 2025 Alquilá Seguro Uruguay. Todos los derechos reservados.</p>
        <div className="flex gap-6" data-id="element-80">
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-81">
            Términos
          </a>
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-82">
            Privacidad
          </a>
          <a href="#" className="hover:text-zinc-400 transition-colors" data-id="element-83">
            Contacto
          </a>
        </div>
      </div>
    </footer>;
}